var map = {
	"./apple-pie-1.svg": "471b",
	"./apple-pie-2.svg": "6e41",
	"./birthday-cake-1.svg": "cade",
	"./birthday-cake-2.svg": "aff0",
	"./cake-1.svg": "479c",
	"./cake-10.svg": "552f",
	"./cake-11.svg": "6edd",
	"./cake-12.svg": "524a",
	"./cake-13.svg": "65a1",
	"./cake-14.svg": "95ed",
	"./cake-15.svg": "4def",
	"./cake-16.svg": "931e",
	"./cake-17.svg": "895b",
	"./cake-18.svg": "1300",
	"./cake-19.svg": "53d4",
	"./cake-2.svg": "2e45",
	"./cake-20.svg": "7a28",
	"./cake-21.svg": "016d",
	"./cake-22.svg": "29d7",
	"./cake-23.svg": "ff55",
	"./cake-3.svg": "9776",
	"./cake-4.svg": "6b43",
	"./cake-5.svg": "7e02",
	"./cake-6.svg": "00f1",
	"./cake-7.svg": "608e",
	"./cake-8.svg": "45c4",
	"./cake-9.svg": "594f",
	"./chocolate-cake.svg": "02ed",
	"./cupcake-1.svg": "20ac",
	"./cupcake-2.svg": "bb1f",
	"./cupcake-3.svg": "5211",
	"./cupcake-4.svg": "fa7a",
	"./cupcake-5.svg": "eee2",
	"./dessert.svg": "9f19",
	"./king-cake.svg": "ebc3",
	"./muffin-1.svg": "b923",
	"./muffin-2.svg": "0ab0",
	"./muffin-3.svg": "0477",
	"./pie.svg": "022b",
	"./piece-of-cake.svg": "094e",
	"./roscon-de-reyes.svg": "6b8b",
	"./sweet-bread.svg": "f51a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2316";